import { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { api, errMsg } from "@/lib/api";

const CHECKS = [["appearance_ok", "Colour and look are right"], ["smell_ok", "Smell is fresh (not too sour)"], ["consistency_ok", "Thickness / consistency is right"]];

export function QcBadge({ qc }) {
  if (!qc) return <span className="rounded-full bg-amber-100 px-2 py-0.5 text-xs font-semibold text-amber-800">QC pending</span>;
  return qc.status === "passed"
    ? <span className="rounded-full bg-emerald-100 px-2 py-0.5 text-xs font-semibold text-emerald-800">QC passed · released</span>
    : <span className="rounded-full bg-rose-100 px-2 py-0.5 text-xs font-semibold text-rose-700">QC failed · blocked</span>;
}

export function BatchQc({ batch, onDone }) {
  const [open, setOpen] = useState(false);
  const [f, setF] = useState({ appearance_ok: true, smell_ok: true, consistency_ok: true, temperature_c: "", notes: "" });
  const save = async (status) => {
    try {
      const { data } = await api.post(`/production/batches/${batch.id}/qc`, { ...f, status, temperature_c: f.temperature_c === "" ? null : Number(f.temperature_c) });
      toast.success(status === "passed" ? "Batch released for delivery" : `Batch blocked. ${data.lots_written_off} stock lot(s) written off`);
      setOpen(false); onDone();
    } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <>
      <QcBadge qc={batch.qc} />
      {!batch.qc && <Button size="sm" variant="outline" className="ml-2 h-7 text-xs" onClick={() => setOpen(true)} data-testid={`qc-btn-${batch.id}`}>Quality check</Button>}
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-sm" data-testid={`qc-dialog-${batch.id}`}>
          <DialogHeader><DialogTitle className="font-display">Quality check</DialogTitle>
            <DialogDescription>Check the batch before it goes out. A failed batch is blocked and its stock is written off.</DialogDescription></DialogHeader>
          <div className="space-y-2 text-sm">
            {CHECKS.map(([k, label]) => (
              <label key={k} className="flex items-center gap-2"><input type="checkbox" checked={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.checked })} data-testid={`qc-${k}`} />{label}</label>
            ))}
            <Input type="number" placeholder="Batter temperature °C (optional)" value={f.temperature_c} onChange={(e) => setF({ ...f, temperature_c: e.target.value })} data-testid="qc-temp-input" />
            <Input placeholder="Notes (optional)" value={f.notes} onChange={(e) => setF({ ...f, notes: e.target.value })} data-testid="qc-notes-input" />
          </div>
          <DialogFooter className="gap-2">
            <Button variant="outline" className="border-rose-300 text-rose-700" onClick={() => save("failed")} data-testid="qc-fail-btn">Fail and block</Button>
            <Button className="bg-[#0F382C] hover:bg-[#134E3A]" onClick={() => save("passed")} data-testid="qc-pass-btn">Pass and release</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
}
